// extracted by mini-css-extract-plugin
export default {"container_pagination":"styles_container_pagination__oyYNY"};